import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VenueServiceeService } from '../../services/venue-service/venue-servicee.service';
import { JoinServiceService } from '../../services/join-service.service';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RecaptchaComponent } from 'ng-recaptcha';
import { ToastrService } from 'ngx-toastr';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

declare var CircularJSON: any;

@Component({
  selector: 'app-join-form',
  templateUrl: './join-form.component.html',
  styleUrls: ['./join-form.component.css']
})
export class JoinFormComponent implements OnInit {
  hash: string;
  fields: any;
  venueSetting: any;
  currentPage: number;
  activePages: any[];
  modalIstance: NgbModalRef;
  @ViewChild('tcsModal') tcsModal: ElementRef;
  @ViewChild('successModal') successModal: ElementRef;
  // @ViewChild('myRecaptcha') myRecaptcha: RecaptchaComponent;
  captchaRes: boolean;
  isTcagreed: boolean;
  doingSubmit: boolean;
  successMsg: string;
  alerts: any[];
  pageState: string;
  field: any;

  constructor(
    private router: ActivatedRoute,
    private venue: VenueServiceeService,
    private joinService: JoinServiceService,
    private myModalService: NgbModal,
    private toastr: ToastrService,
    private mySpinner: Ng4LoadingSpinnerService
  ) {
    // this.captchaRes = true;
  }

  ngOnInit() {
    this.router.queryParamMap.subscribe(q => {
      this.hash = q['params']['v_id'];
      this.field = {};
      this.field['value'] = '';

      this.venueSetting = this.router.snapshot.data['venueSettings'];
      if (this.venueSetting.setting.value) {
        document.documentElement.style.setProperty('--primary-color', this.venueSetting.setting.value.primary_colour ,'important'); //set primary value
        document.documentElement.style.setProperty('--btn-bg', this.venueSetting.setting.value.button_background ,'important'); //set button bg
        document.documentElement.style.setProperty('--btn-fontc', this.venueSetting.setting.value.button_font ,'important'); //set font colour
        document.documentElement.style.setProperty('--btn-border', this.venueSetting.setting.value.button_active_border ,'important'); //set border
        document.documentElement.style.setProperty('--btn-activebg', this.venueSetting.setting.value.button_active_bg ,'important'); //set active bg
        document.documentElement.style.setProperty('--btn-activef', this.venueSetting.setting.value.button_active_font ,'important'); //set active font
        document.documentElement.style.setProperty('--btn-activebrd', this.venueSetting.setting.value.background_button ,'important'); //set active brd
        document.documentElement.style.setProperty('--color', this.venueSetting.setting.value.font_color ,'important'); //set active brd
        document.documentElement.style.setProperty('--pg-bg', this.venueSetting.setting.value.page_background ,'important'); //set active brd
      }
      this.venue.getFieldSetting(this.hash).subscribe(s => {
        this.fields = s.data;
        this.getActivePage();
        if (this.activePages.length > 0) {
          // this.activePages.sort()
          this.currentPage = this.activePages[0];
        }
        if (this.fields.custom_fields.length > 0) {
          this.fields.custom_fields.forEach(f => {
            f.multi_values = JSON.parse(f.multi_values);
          })
        }
      }, e => {
        console.log(e);
        this.toastr.error(e.error.message, '', {
          positionClass: 'toast-bottom-right'
        });
      });
    })

  }

  initForm() {
    this.hash = this.router.snapshot.queryParams['v_id']

    this.venue.getVenueSetting(this.hash).subscribe(res => {
      this.venueSetting = res;
    }, e => {
      this.toastr.error(e.error.message, '', {
        positionClass: 'toast-bottom-right'
      });
    });

    this.venue.getFieldSetting(this.hash).subscribe(s => {
      this.fields = s.data;
      this.getActivePage();
      if (this.activePages.length > 0) {
        // this.activePages.sort()
        this.currentPage = this.activePages[0];
      }
      if (this.fields.custom_fields.length > 0) {
        this.fields.custom_fields.forEach(f => {
          f.multi_values = JSON.parse(f.multi_values);
        })
      }
    }, e => {
      console.log(e);
      this.toastr.error(e.error.message, '', {
        positionClass: 'toast-bottom-right'
      });
    })
  }

  getBgImg() {
    return this.venueSetting.use_background_image ? this.venueSetting.background_image : '';
  }

  getActivePage() {
    this.activePages = [];

    for (let k in this.fields) {
      this.fields[k].forEach(f => {
        if (f.active == true && this.activePages.indexOf(f.page)<0) {
          this.activePages.push(f.page);
        }
      });
    }
    this.activePages.sort();
  }

  nextPage() {


    let isValid = true;

    for (let k in this.fields) {
      this.fields[k].forEach(f => {
        console.log(f.value);
        if (f.page == this.currentPage && f.active == true) {
          if (f['bepoz_field_name'] && f.formControl) {
            f.formControl.markAsDirty();
            if (f.formControl.invalid) {
              f.invalidTooltip.open();
            }

          }
          if (f['bepoz_custom_field_name'] && f.formControl) {
            f.formControl.markAsDirty();
            if (f.formControl.invalid) {
              f.invalidTooltip.open();
            }
          }
          if (f.formControl && !f.formControl.valid) {
            isValid = f.formControl.valid;
          }

        }
      });

    }

    if (isValid) {
      // change the page
      console.log(isValid);
      if (this.activePages.indexOf(this.currentPage) < this.activePages.length - 1) {
        this.currentPage = this.activePages[this.activePages.indexOf(this.currentPage) + 1];
        this.pageState = 'forward';
      }
    }
  }

  prePage() {
    this.currentPage = this.activePages[this.activePages.indexOf(this.currentPage) - 1];
    this.pageState = 'backward';
  }

  openTCModal(modalRef: ElementRef) {
    this.alerts = [];
    this.captchaRes = false;
    this.isTcagreed = false;
    this.modalIstance = this.myModalService.open(modalRef, { centered: true, windowClass: 'voucher-modal-container', backdrop: false });
  }


  join() {
    this.doingSubmit = true;
    this.modalIstance.close();
    this.mySpinner.show();
    this.joinService.addMember(this.hash, this.fields).subscribe(s => {
      console.log(s);
      this.mySpinner.hide();
      // success modal
      this.successMsg = s.message;
      this.modalIstance.close();
      this.modalIstance = this.myModalService.open(this.successModal, { size: 'sm', centered: true, windowClass: 'voucher-modal-container' });
      this.doingSubmit = false;

      // reset the form
      this.initForm();

    }, e => {
      console.log(e);
      this.doingSubmit = false;
      this.mySpinner.hide();
      this.toastr.error(e.error.message, '', {
        positionClass: 'toast-bottom-right'
      });
    });
  }

  doSubmit() {
    let isValid = true;
    for (let k in this.fields) {
      this.fields[k].forEach(f => {
        if (f.formControl && f.page == this.currentPage && f.active == true) {
          if (f['bepoz_field_name']) {
            f.formControl.markAsDirty();
            if (f.formControl.invalid) {
              f.invalidTooltip.open();
            }
          }
          if (f['bepoz_custom_field_name']) {
            f.formControl.markAsDirty();
            if (f.formControl.invalid) {
              f.invalidTooltip.open();
            }
          }
          if (!f.formControl.valid) {
            isValid = f.formControl.valid;
          }
        }
      });
    }

    if (isValid) {
      // console.log(this.fields);
      this.openTCModal(this.tcsModal);
    }
  };

}
